<template>
  <div v-if="!isMobile()">
    <v-hover v-slot="{ hover }">
      <v-card
        class="option-card d-flex justify-center align-center flex-column"
        :style="hover ? 'box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.25);' : ''"
        :key="key"
      >
        <div v-if="loading">
          <v-progress-circular
            class="ma-3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <div v-if="!loading" style="width: 100%">
          <v-toolbar
            width="100%"
            height="35"
            color="#39424e"
            dark
            class="main-bar d-flex justify-center"
            >Opção {{ number }}
          </v-toolbar>

          <div class="d-flex">
            <div>
              <v-row class="ma-0" justify="space-around" align="center">
                <v-col class="header-label">Coberturas</v-col>
                <v-col class="header-label">Capital Segurado</v-col>
                <v-col class="header-label">Custo ao mês</v-col>
                <v-col cols="12" class="my-0">
                  <v-divider></v-divider>
                </v-col>
              </v-row>

              <v-row
                v-for="(cover, index) in coberturas"
                :key="index"
                class="ma-0"
              >
                <v-col>
                  <v-checkbox
                    v-if="cover.id !== 'MORTE + ADT'"
                    :readonly="cover.valorCapital > 0"
                    :input-value="cover.valorCapital > 0"
                    @click="unmark(cover)"
                    class="ma-0"
                    hide-details
                  >
                    <template v-slot:label>
                      <span style="font-size: 12px">{{ cover.name }}</span>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    v-else
                    input-value="true"
                    disabled
                    class="ma-0"
                    hide-details
                  >
                    <template v-slot:label>
                      <span style="font-size: 12px">{{ cover.name }}</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col class="content-label d-flex justify-center align-center">
                  R$
                  <v-currency-field
                    type="number"
                    class="ml-2 ma-0 pa-0"
                    :key="update"
                    v-if="cover.id !== 'SAF FAM'"
                    hide-details
                    v-model="cover.valorCapital"
                    @change="recalculate(), getTotalValue()"
                  />
                  <v-currency-field
                    type="number"
                    class="ml-2 ma-0 pa-0"
                    hide-details
                    v-else
                    readonly
                    v-model="cover.valorCapital"
                    @change="recalculate(), getTotalValue()"
                  />
                </v-col>
                <v-col
                  class="content-label d-flex justify-center align-center"
                  :key="cover.valorCapital"
                >
                  {{
                    cover.valorCapital == 0
                      ? "Opcional"
                      : cover.monthly.toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          style: "currency",
                          currency: "BRL",
                        })
                  }}
                </v-col>
              </v-row>
            </div>

            <div
              @click="select"
              :class="hover ? 'active-price-card' : 'price-card'"
            >
              <div class="d-flex flex-column align-end mt-8">
                <strong class="number-label">Você pagará: </strong>
                <h3
                  class="price-label"
                  :style="hover ? 'color: white' : 'color: #00c7ba'"
                >
                  {{
                    value.toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </h3>
                <span class="number-label">por mês</span>
              </div>

              <div class="d-flex flex-column align-center">
                <div>
                  <v-img
                    width="110px"
                    contain
                    src="../../../../assets/logo_icatu.png"
                  ></v-img>
                </div>

                <v-btn text color="primary">
                  <strong
                    class="button-label mt-15"
                    :style="hover ? 'color: white' : 'color: #00c7ba'"
                  >
                    Contratar
                  </strong>
                </v-btn>
              </div>

              <v-img
                v-if="!hover && haveImage"
                style="
                  position: absolute;
                  right: 25px;
                  transform: translate(70%, -10%);
                "
                src="../../../../assets/arrow_large.svg"
                contain
              ></v-img>

              <v-img
                v-if="hover && haveImage"
                style="
                  position: absolute;
                  right: 25px;
                  transform: translate(45%, -10%);
                "
                src="../../../../assets/arrow_large_painted.svg"
                contain
              ></v-img>
            </div>
          </div>
        </div>
      </v-card>
    </v-hover>
  </div>

  <div v-else>
    <v-hover v-slot="{ hover }">
      <v-card
        class="option-card d-flex justify-center align-center flex-column"
        :style="hover ? 'box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.25);' : ''"
      >
        <div v-if="loading">
          <v-progress-circular
            class="ma-3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <div v-if="!loading" style="width: 100%">
          <v-toolbar
            width="100%"
            height="35"
            color="#39424e"
            dark
            class="main-bar d-flex justify-center"
          >
            Opção {{ number }}
          </v-toolbar>

          <div class="d-flex" style="width: 100%">
            <div class="d-flex flex-column align-center" style="width: 100%">
              <v-row
                v-for="(cover, index) in coberturas"
                :key="index"
                class="ma-3"
                style="background: #f2f2f2; border-radius: 8px"
              >
                <v-col cols="12">
                  <span class="header-label">Cobertura</span>
                  <v-checkbox
                    v-if="cover.id !== 'MORTE + ADT'"
                    :readonly="cover.valorCapital > 0"
                    :input-value="cover.valorCapital > 0"
                    @click="unmark(cover)"
                    class="ma-0"
                    hide-details
                    :label="cover.name"
                  ></v-checkbox>
                  <v-checkbox
                    v-else
                    disabled
                    :input-value="true"
                    class="ma-0"
                    hide-details
                    :label="cover.name"
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="12">
                  <span class="header-label">Capital Segurado</span>
                  <v-currency-field
                    type="number"
                    class="ml-2 ma-0 pa-0"
                    :key="update"
                    hide-details
                    v-model="cover.valorCapital"
                    @change="recalculate(), getTotalValue()"
                  />
                </v-col>
                <v-col cols="12">
                  <span class="header-label">Custo ao mês</span>
                  {{
                    cover.optional
                      ? "Opcional"
                      : cover.monthly.toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          style: "currency",
                          currency: "BRL",
                        })
                  }}
                </v-col>
              </v-row>
            </div>
          </div>

          <div
            @click="select"
            :class="hover ? 'active-price-card' : 'price-card'"
          >
            <div class="d-flex flex-column align-end mt-8">
              <strong class="number-label">Você pagará: </strong>
              <h3
                class="price-label"
                :style="hover ? 'color: white' : 'color: #00c7ba'"
              >
                {{
                  value.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </h3>
              <span class="number-label">por mês</span>
            </div>

            <div class="d-flex flex-column align-center mt-5 mb-5">
              <div class="mb-3">
                <v-img
                  width="80px"
                  contain
                  src="../../../../assets/logo_icatu.png"
                ></v-img>
              </div>

              <v-btn text color="primary">
                <strong
                  class="button-label"
                  :style="hover ? 'color: white' : 'color: #00c7ba'"
                >
                  Contratar
                </strong>
              </v-btn>
            </div>

            <v-img
              v-if="!hover && haveImage"
              style="
                position: absolute;
                right: 25px;
                transform: translate(70%, -10%);
              "
              src="../../../../assets/arrow_large.svg"
              contain
            ></v-img>

            <v-img
              v-if="hover && haveImage"
              style="
                position: absolute;
                right: 25px;
                transform: translate(45%, -10%);
              "
              src="../../../../assets/arrow_large_painted.svg"
              contain
            ></v-img>
          </div>
        </div>
      </v-card>
    </v-hover>
  </div>
</template>

<style scoped>
.option-card {
  background: #ffffff;
  border: 1px solid #00c7ba;
  box-sizing: border-box;
  border-radius: 6px !important;
  transition: 0.3s;
}

.price-card {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-left: 1px solid #e5e5e5;
  width: 30%;
}

.active-price-card {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background-color: #00c7ba;
  border-left: 1px solid #e5e5e5;
  width: 30%;
}

@media only screen and (max-width: 600px) {
  .price-card {
    margin-left: 0px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    border-left: 1px solid #e5e5e5;
    width: 100%;
  }

  .active-price-card {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background-color: #00c7ba;
    border-left: 1px solid #e5e5e5;
    width: 100%;
  }
}

.main-bar {
  background: #39424e;
  border-radius: 6px 6px 0px 0px !important;
  font-weight: bold;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.15px;
  text-transform: uppercase;
  color: #ffffff;
}

.header-label {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #000000;
}

.content-label {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: #39424e;
}

.price-label {
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #00c7ba;
}

.number-label {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #000000;
}

.button-label {
  font-weight: bold;
  font-size: 21px;
  line-height: 31px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #00c7ba;
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
const { adjust_death_adt_values } = require("@/services/CoverService");
import { VMoney } from "v-money";

export default {
  name: "Option",

  props: {
    number: Number,
    result: Object,
    haveImage: Boolean,
  },

  async mounted() {
    await this.apiService
      .get(`api/vida/produtos?date=${this.result.dataNascimento}`)
      .then(async (response) => {
        this.loading = true;
        this.coberturas = response.coberturas;
        this.$root.$emit("stop");
        this.formatCovers();

        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

    this.getTotalValue();
  },

  data: () => ({
    key: false,
    loading: false,
    accept: true,
    value: 0,
    coberturas: [],
    covers: [],
    update: 0,
    apiService: new ApiService(),
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false,
    },
  }),

  directives: { money: VMoney },

  methods: {
    unmark(cover) {
      if (cover.valorCapital > 0) {
        cover.valorCapital = 0;
        this.key = !this.key;
      } else if (cover.id == "SAF FAM") {
        cover.valorCapital = 5500;
      } else {
        let filhos = parseInt(this.result.numeroFilhos);
        filhos = filhos == 0 ? 1 : filhos;
        let renda = this.result.valorRenda;
        cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;
      }
      this.recalculate();
      this.getTotalValue();
    },
    formatCovers() {
      let filhos = parseInt(this.result.numeroFilhos);
      filhos = filhos == 0 ? 1 : filhos;
      let renda = this.result.valorRenda;
      this.coberturas.forEach((cover) => {
        if (this.number === 1) {
          switch (cover.id) {
            case "IPA (S/ MAJ)":
              cover.order = 2;
              cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;

              if (cover.valorCapital > 5000000) {
                cover.valorCapital = 5000000;
              }

              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);
              break;
            case "MORTE + ADT":
              cover.order = 1;
              cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;
              if (cover.valorCapital <= 25000) {
                cover.valorCapital = 25000;
              }

              if (cover.valorCapital > 5000000) {
                cover.valorCapital = 5000000;
              }
              break;
            case "SAF FAM":
              cover.order = 3;
              cover.valorCapital = 5500;
              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);
              break;
            case "DG":
              cover.order = 4;
              cover.valorCapital = 0;
              cover.monthly = 0;
              break;
            case "IED":
              cover.order = 5;
              cover.valorCapital = 0;
              cover.monthly = 0;
              break;
            case "IEA":
              cover.order = 6;
              cover.valorCapital = 0;
              cover.monthly = 0;
              break;
            default:
              cover.valorCapital = 0;
              cover.monthly = 0;
              break;
          }
        } else {
          switch (cover.id) {
            case "IPA (S/ MAJ)":
              cover.order = 2;
              cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;

              if (cover.valorCapital > 5000000) {
                cover.valorCapital = 5000000;
              }

              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);
              break;
            case "MORTE + ADT":
              cover.order = 1;
              cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;
              if (cover.valorCapital <= 25000) {
                cover.valorCapital = 25000;
              }

              if (cover.valorCapital > 5000000) {
                cover.valorCapital = 5000000;
              }
              break;
            case "SAF FAM":
              cover.order = 3;
              cover.valorCapital = 5500;
              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);
              break;
            case "DG":
              cover.order = 4;
              cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;

              if (cover.valorCapital > 1000000) {
                cover.valorCapital = 1000000;
              }

              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);

              break;
            case "IED":
              cover.order = 5;
              cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;

              if (cover.valorCapital > 1000000) {
                cover.valorCapital = 1000000;
              }

              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);
              break;
            case "IEA":
              cover.order = 6;
              cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;
              if (cover.valorCapital > 5000000) {
                cover.valorCapital = 5000000;
              }

              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);
              break;
            default:
              cover.order = 0;
              cover.valorCapital = filhos >= 2 ? renda * 24 * 2 : renda * 24;
              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);
              break;
          }
        }
        this.value += cover.monthly;
      });

      const order1Index = this.coberturas.map((x) => x.order).indexOf(1);
      adjust_death_adt_values(this.coberturas[order1Index], this.coberturas);

      this.coberturas.sort(function (a, b) {
        return parseInt(a["order"], 10) - parseInt(b["order"], 10);
      });

      const cover = this.coberturas.find((x) => x.id === "MORTE + ADT");

      this.coberturas.forEach((c) => {
        switch (c.id) {
          case "DG":
            if (c.valorCapital > cover.valorCapital * 2) {
              c.valorCapital = cover.valorCapital * 2;
            }
            break;
          case "IED":
            if (c.valorCapital > cover.valorCapital) {
              c.valorCapital = cover.valorCapital;
            }
            break;
          default:
            break;
        }
      });

      // if (cover.id == "SAF FAM") {
      //   cover.valorCapital = (5500).toFixed(2);
      // } else {
      //   if (this.number === 2) {
      //     cover.valorCapital = (renda * 24 * filhos).toFixed(2);
      //   } else {
      //     cover.valorCapital = (renda * filhos).toFixed(2);
      //   }
      // }
      this.value >= 30 ? this.value : (this.value = 30);
    },

    getTotalValue() {
      this.value = 0;

      this.coberturas.forEach((cover) => {
        if (cover.valorCapital > 0) {
          this.value += cover.monthly;
          this.key = !this.key;
        }
      });
      this.value >= 30 ? this.value : (this.value = 30);
    },

    async recalculate() {
      try {
        this.loading = true;

        [...this.coberturas]
          .sort((a, b) => b.order - a.order)
          .forEach((cover) => {
            if (cover.valorCapital > 0 && cover.id != "MORTE + ADT") {
              switch (cover.id) {
                case "IPA (S/ MAJ)":
                  if (cover.valorCapital > 5000000) {
                    cover.valorCapital = 5000000;
                  }
                  break;
                case "SAF FAM":
                  if (cover.valorCapital <= 5500) {
                    cover.valorCapital = 5500;
                    this.update++;
                  }
                  break;
                case "DG":
                  if (cover.valorCapital > 1000000) {
                    cover.valorCapital = 1000000;
                  }
                  break;
                case "IED":
                  if (cover.valorCapital > 1000000) {
                    cover.valorCapital = 1000000;
                  }
                  break;
                case "IEA":
                  if (cover.valorCapital > 5000000) {
                    cover.valorCapital = 5000000;
                  }
                  break;
                default:
                  break;
              }
              cover.monthly = 0;
              cover.monthly =
                parseFloat(cover.valorCapital) * parseFloat(cover.tax);
            } else if (cover.id == "MORTE + ADT") {
              if (cover.valorCapital <= 25000) {
                cover.valorCapital = 25000;
              }

              if (cover.valorCapital > 5000000) {
                cover.valorCapital = 5000000;
              }
              this.update++;
              adjust_death_adt_values(cover, this.coberturas);
            }
          });

        const cover = this.coberturas.find((x) => x.id === "MORTE + ADT");

        this.coberturas.forEach((c) => {
          switch (c.id) {
            case "DG":
              if (c.valorCapital > cover.valorCapital * 2) {
                c.valorCapital = cover.valorCapital * 2;
              }
              break;
            case "IED":
              if (c.valorCapital > cover.valorCapital) {
                c.valorCapital = cover.valorCapital;
              }
              break;
            default:
              break;
          }
        });

        this.key = !this.key;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }

      // let payload = {
      //   codigoProduto: "232455_1_0",
      //   coberturas: this.coberturas.filter((x) => x.enabled),
      // };

      // payload.proponente = {
      //   pessoaFisica: this.result.
      // };

      // payload.cpf =
      //   payload.cpf.replace(/\D/g, "");

      // await this.apiService
      //   .post(`api/vida/cotarVida`, payload)
      //   .then((response) => {
      //     this.covers = response;
      //     this.coberturas.map((cobertura, index) => {
      //       cobertura.monthly = this.covers.coberturas[index].valorPremio;
      //     });
      //     this.loading = false;
      //   })
      //   .catch(() => {
      //   });
      this.value >= 30 ? this.value : (this.value = 30);
    },

    select() {
      this.loading = true;

      const model = {
        number: this.number,
        covers: this.coberturas.filter((x) => x.valorCapital > 0),
      };

      this.$emit("selectItem", model);

      this.loading = false;
    },

    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
